const ORTHO_DIRECTIONS = [
  [-1, 0],
  [1, 0],
  [0, -1],
  [0, 1],
];

export const toCellKey = (row, col, cols) => row * cols + col;

export const isInsideBoard = (board, row, col) => (
  row >= 0 &&
  row < board.length &&
  col >= 0 &&
  col < board[0].length
);

export const getColorIslands = (board, colorIndex) => {
  if (!Array.isArray(board) || board.length === 0 || board[0].length === 0) {
    return [];
  }

  const rows = board.length;
  const cols = board[0].length;
  const visited = new Set();
  const islands = [];

  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      const startKey = toCellKey(row, col, cols);
      if (visited.has(startKey) || board[row][col] !== colorIndex) {
        continue;
      }

      const stack = [[row, col]];
      const cells = [];
      let minKey = startKey;

      while (stack.length > 0) {
        const [r, c] = stack.pop();
        const key = toCellKey(r, c, cols);
        if (visited.has(key)) {
          continue;
        }
        visited.add(key);

        if (board[r][c] !== colorIndex) {
          continue;
        }

        cells.push([r, c]);
        if (key < minKey) {
          minKey = key;
        }

        for (const [dr, dc] of ORTHO_DIRECTIONS) {
          const nr = r + dr;
          const nc = c + dc;
          if (!isInsideBoard(board, nr, nc)) {
            continue;
          }
          const nextKey = toCellKey(nr, nc, cols);
          if (!visited.has(nextKey)) {
            stack.push([nr, nc]);
          }
        }
      }

      if (cells.length > 0) {
        islands.push({ rootKey: minKey, size: cells.length, cells });
      }
    }
  }

  return islands;
};

export const getIslandRootLookup = (islands, cols) => {
  const rootByKey = new Map();
  islands.forEach((island) => {
    island.cells.forEach(([row, col]) => {
      rootByKey.set(toCellKey(row, col, cols), island.rootKey);
    });
  });
  return rootByKey;
};

export { ORTHO_DIRECTIONS };
